import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../i18n/LanguageContext';
import { getAlternateRoute } from '../i18n/translations';

export default function SEO({
  title,
  description,
  pageKey,
  image = 'https://assets.auxodev.dk/assets/b835980a-208f-4a2a-a4d0-0b3689e0c3e6/44120024-e095-446b-8ee7-1dea28fabce6.jpg',
}) {
  const { lang, t, currentPath } = useLanguage();

  const finalTitle = title || (pageKey && t.meta[pageKey]?.title) || t.meta.home.title;
  const finalDescription = description || (pageKey && t.meta[pageKey]?.description) || t.meta.home.description;

  // Base domain (safe fallback for SSR/client)
  const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : 'https://elianawine.dk';

  // Calculate paths for both languages
  const daPath = getAlternateRoute(currentPath, 'da');
  const enPath = getAlternateRoute(currentPath, 'en');

  const currentUrl = `${origin}${currentPath === '' ? '/' : currentPath}`;
  const canonicalUrl = `${origin}${lang === 'en' ? enPath : daPath}`;
  const daUrl = `${origin}${daPath}`;
  const enUrl = `${origin}${enPath}`;
  const xDefaultUrl = daUrl; // Danish is the primary/default language

  const ogLocale = lang === 'en' ? 'en_US' : 'da_DK';

  return (
    <Helmet>
      {/* HTML Language Tag */}
      <html lang={lang} />

      {/* Primary Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />

      {/* Canonical Link */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Hreflang Tags */}
      <link rel="alternate" hrefLang="da" href={daUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={xDefaultUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={t.meta.siteName} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:locale" content={ogLocale} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
